import { Component, Host, Prop, h } from '@stencil/core';

import { shouldOpenAcceptModal } from '../../../actions/actions.kelley-buys-your-car-offer';
import {
  trackKelleyBuysYourCarAcceptedImpression,
  trackKelleyBuysYourCarModalImpression,
  trackKelleyBuysYourCarOfferAccept,
  trackKelleyBuysYourCarOfferAcceptImpression,
} from '../../../tracking/tracking.unified-disposal';

import { AcceptedMessage, LegalText } from './Shared';

@Component({
  tag: 'kelley-buys-your-car',
  styleUrl: 'kelley-buys-your-car.css',
})
export class KelleyBuysYourCar {
  @Prop() offerAmount: string = '';
  @Prop() shouldDisplay: boolean = false;
  @Prop() isSubmitting: boolean = false;
  @Prop() isDisposalAccepted: boolean = false;
  @Prop() isFakeDoor: boolean = false;

  kelleyBuysYourCarAcceptOfferDialog: HTMLKelleyBuysYourCarAcceptDialogElement;

  componentWillLoad() {
    trackKelleyBuysYourCarOfferAcceptImpression();
  }

  componentDidLoad() {
    shouldOpenAcceptModal() && this.openAcceptModal();
  }

  openAcceptModal = () => {
    trackKelleyBuysYourCarOfferAccept();
    this.kelleyBuysYourCarAcceptOfferDialog.modal.open();
    trackKelleyBuysYourCarModalImpression();
  };

  getTitle = () => {
    let title = 'Sell your car directly to Kelley Blue Book';
    if (this.isDisposalAccepted) {
      title = this.isFakeDoor
        ? "Thank you for your interest. Unfortunately this option isn't available. But, you can still use Instant Cash Offer or Private Seller Exchange"
        : 'Thank you for Accepting the Kelley Buys Your Car Offer!';
    }
    const titleContainerClass = { 'text-lg font-extrabold font-montserrat': true, 'text-center': this.isDisposalAccepted };
    return <h3 class={titleContainerClass}>{title}</h3>;
  };

  render() {
    if (!this.shouldDisplay) {
      return;
    }

    return (
      <Host>
        <div class="bg-clrs-off-white rounded-lg shadow-lg p-6 pt-4 mb-7" data-testId="kbyc-accept">
          {this.renderContent()}
        </div>
        <kelley-buys-your-car-accept-dialog
          offerAmount={this.offerAmount}
          isDisposalAccepted={this.isDisposalAccepted}
          isSubmitting={this.isSubmitting}
          isFakeDoor={this.isFakeDoor}
          ref={(el) => (this.kelleyBuysYourCarAcceptOfferDialog = el)}
        />
      </Host>
    );
  }

  renderContent() {
    if (this.isDisposalAccepted) {
      return this.isFakeDoor ? this.renderFakeDoorAccepted() : this.renderAccepted();
    }
    return this.renderToAccept();
  }

  renderAccepted() {
    trackKelleyBuysYourCarAcceptedImpression();
    return (
      <div class="flex flex-col items-center max-sm:px-4 max-sm:pb-6">
        <svg-icon icon="circled-check-mark" height="53px" width="53px" />
        <div class="mt-3 mb-8">{this.getTitle()}</div>
        <div class="items-center max-w-[600px] pb-2 mdLrg:pb-10">
          <AcceptedMessage />
          <div class="mt-8 text-xxs">
            <LegalText />
          </div>
        </div>
      </div>
    );
  }

  renderToAccept() {
    return (
      <div class="flex flex-col gap-0.5 text-sm text-black font-open-sans">
        {this.getTitle()}
        <div class="flex justify-between mb-7 max-sm:flex-wrap sm:flex-nowrap">
          <div class="flex flex-col gap-2">
            <span>A dedicated representative will ensuring a smooth and successful experience!</span>
            <span>Virtual Inspection|Online Verification|Digital Documentation</span>
          </div>
          <div class="max-sm:w-full max-sm:mt-8 sm:w-auto max-sm:pr-0 pr-3.5">
            <ico-button data-testId="accept-offer-btn" label="Accept Offer" buttonSize="large" onClick={this.openAcceptModal} />
          </div>
        </div>
        <div class="text-xxs">
          <LegalText />
        </div>
      </div>
    );
  }

  renderFakeDoorAccepted() {
    return (
      <div class="flex flex-col items-center max-sm:px-4">
        <div class="mt-10 mb-8">{this.getTitle()}</div>
      </div>
    );
  }
}
